/*
 * This file is a generated Typescript file for GRPC Gateway, DO NOT MODIFY
 */

import * as fm from "../../../fm"

import * as offerV1 from "./keyapis_subscription_offer_v1.pb"

/**
 * Сервис реализует функционал управления Шаблонами КВ.
 * Шаблон КВ описывает набор технологических планов и правила их применимости для массового создания КВ
 */

/**
 * Сервис Шаблонов КВ
 */
export class OfferTemplateServiceClient {
  /**
   * Конструктор сервиса
   * @param host Адрес хоста
   * @param token Токен доступа
   */
  constructor(
    public host = "",
    public token = ""
  ) { }

  /**
   * Метод получения шаблона КВ.
   * Разрешения: subscription:offer_template:card.
   * Метод доступен для: Token: service, device_admin, ltp_first, admin, mrf, bti, manager. При наличии разрешений
   */
  GetOfferTemplate = (req: GetOfferTemplateRequestDto, init?: RequestInit): Promise<GetOfferTemplateResponseDto> => {
    return fm.request<GetOfferTemplateRequestDto, GetOfferTemplateResponseDto>(`${this.host}/subscription/api/v1/offer_template/${encodeURIComponent(req.id)}${fm.buildQuery(req, ["id"])}`, { ...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод получения списка шаблонов КВ.
   * Разрешения: subscription:offer_template:list.
   * Метод доступен для: Token: service, device_admin, ltp_first, admin, mrf, bti, manager. При наличии разрешений
   */
  GetOfferTemplateList = (req?: GetOfferTemplateListRequestDto, init?: RequestInit): Promise<GetOfferTemplateListResponseDto[]> => {
    return fm.list<GetOfferTemplateListRequestDto, GetOfferTemplateListResponseDto>(`${this.host}/subscription/api/v1/offer_template/list${fm.buildQuery(req)}`, {...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }
  /**
   * Метод получения списка Шаблонов КВ, соответствующих коммерческим возможностям дома.
   * По ОРПОН дома определяет фактически настроенные КВ и возвращает соответствующие им Шаблоны КВ.
   * Разрешения: subscription:offer_template:list.
   * Метод доступен для: Token: service, device_admin, ltp_first, admin, mrf, bti, manager. При наличии разрешений
   */
  GetOfferTemplateByOrponList = (req: GetOfferTemplateByOrponListRequestDto, init?: RequestInit): Promise<GetOfferTemplateByOrponListResponseDto[]> => {
    return fm.list<GetOfferTemplateByOrponListRequestDto, GetOfferTemplateByOrponListResponseDto>(`${this.host}/subscription/api/v1/offer_template_by_orpon/${encodeURIComponent(req.orpon)}/list${fm.buildQuery(req, ["orpon"])}`, {...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }
  /**
   * Метод получения количества шаблонов КВ.
   * Разрешения: subscription:offer_template:list.
   * Метод доступен для: Token: service, device_admin, ltp_first, admin, mrf, bti, manager. При наличии разрешений
   */
  GetOfferTemplateCount = (req?: GetOfferTemplateCountRequestDto, init?: RequestInit): Promise<GetOfferTemplateCountResponseDto> => {
    return fm.request<GetOfferTemplateCountRequestDto, GetOfferTemplateCountResponseDto>(`${this.host}/subscription/api/v1/offer_template/count${fm.buildQuery(req)}`, { ...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод получения количества Шаблонов КВ, соответствующих коммерческим возможностям дома.
   * По ОРПОН дома определяет фактически настроенные КВ и возвращает количество соответствующих им Шаблонов КВ.
   * Разрешения: subscription:offer_template:list.
   * Метод доступен для: Token: service, device_admin, ltp_first, admin, mrf, bti, manager. При наличии разрешений
   */
  GetOfferTemplateByOrponCount = (req: GetOfferTemplateByOrponCountRequestDto, init?: RequestInit): Promise<GetOfferTemplateByOrponCountResponseDto> => {
    return fm.request<GetOfferTemplateByOrponCountRequestDto, GetOfferTemplateByOrponCountResponseDto>(`${this.host}/subscription/api/v1/offer_template_by_orpon/${encodeURIComponent(req.orpon)}/count${fm.buildQuery(req, ["orpon"])}`, { ...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод создания/редактирования шаблона КВ.
   * При отсутствии идентификатора создаёт новый шаблон, при наличии — редактирует существующий.
   * Разрешения: subscription:offer_template:save.
   * Метод доступен для: Token: service, device_admin, ltp_first, admin, mrf, bti, manager. При наличии разрешений
   */
  PostOfferTemplate = (req: PostOfferTemplateRequestDto, init?: RequestInit): Promise<PostOfferTemplateResponseDto> => {
    return fm.request<PostOfferTemplateRequestDto, PostOfferTemplateResponseDto>(`${this.host}/subscription/api/v1/offer_template`, { ...init, method: "POST", body: JSON.stringify(req, fm.replacer), ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод архивации шаблона КВ.
   * Переводит шаблон в статус ARCHIVED.
   * Разрешения: subscription:offer_template:remove.
   * Метод доступен для: Token: service, device_admin, ltp_first, admin, mrf, bti, manager. При наличии разрешений
   */
  DeleteOfferTemplate = (req: DeleteOfferTemplateRequestDto, init?: RequestInit): Promise<DeleteOfferTemplateResponseDto> => {
    return fm.request<DeleteOfferTemplateRequestDto, DeleteOfferTemplateResponseDto>(`${this.host}/subscription/api/v1/offer_template/${encodeURIComponent(req.id)}${fm.buildQuery(req, ["id"])}`, { ...init, method: "DELETE", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод восстановления шаблона КВ из архива.
   * Переводит шаблон в статус ACTIVE.
   * Разрешения: subscription:offer_template:restore:save.
   * Метод доступен для: Token: service, device_admin, ltp_first, admin, mrf, bti, manager. При наличии разрешений
   */
  PostOfferTemplateRestore = (req: PostOfferTemplateRestoreRequestDto, init?: RequestInit): Promise<PostOfferTemplateRestoreResponseDto> => {
    return fm.request<PostOfferTemplateRestoreRequestDto, PostOfferTemplateRestoreResponseDto>(`${this.host}/subscription/api/v1/offer_template/${encodeURIComponent(req.id)}/restore`, { ...init, method: "POST", body: JSON.stringify(req, fm.replacer), ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

}

/**
 * Справочник типов биллинговых систем
 */
export enum OfferTemplateApplicabilityRulesBillingSystemType {
  /**
   * Значение не указано
   */
  BILLING_SYSTEM_TYPE_UNKNOWN = "BILLING_SYSTEM_TYPE_UNKNOWN",
  /**
   * Автоматизированная система расчётов макрорегионального филиала/АСР МРФ
   */
  ASR_MRF = "ASR_MRF",
  /**
   * Платформа Ключ
   */
  KEY_PLATFORM = "KEY_PLATFORM",
}
/**
 * Справочник типов биллинговых систем
 */
export type OfferTemplateApplicabilityRulesBillingSystemTypeResponseEnum = keyof typeof OfferTemplateApplicabilityRulesBillingSystemType
/**
 * Справочник типов биллинговых систем
 */
export type OfferTemplateApplicabilityRulesBillingSystemTypeRequestEnum = Exclude<OfferTemplateApplicabilityRulesBillingSystemTypeResponseEnum, "BILLING_SYSTEM_TYPE_UNKNOWN">;

/**
 * Справочник типов клиентов
 */
export enum OfferTemplateApplicabilityRulesClientType {
  /**
   * Значение не указано
   */
  CLIENT_TYPE_UNKNOWN = "CLIENT_TYPE_UNKNOWN",
  /**
   * Управляющая компания
   */
  MANAGEMENT_COMPANY = "MANAGEMENT_COMPANY",
  /**
   * Домофонная компания
   */
  INTERCOM_COMPANY = "INTERCOM_COMPANY",
}
/**
 * Справочник типов клиентов
 */
export type OfferTemplateApplicabilityRulesClientTypeResponseEnum = keyof typeof OfferTemplateApplicabilityRulesClientType
/**
 * Справочник типов клиентов
 */
export type OfferTemplateApplicabilityRulesClientTypeRequestEnum = Exclude<OfferTemplateApplicabilityRulesClientTypeResponseEnum, "CLIENT_TYPE_UNKNOWN">;

/**
 * Справочник типов договорных схем
 */
export enum OfferTemplateApplicabilityRulesContractType {
  /**
   * Значение не указано
   */
  CONTRACT_TYPE_UNKNOWN = "CONTRACT_TYPE_UNKNOWN",
  /**
   * Договор заключён с юридическим лицом
   */
  B2B = "B2B",
  /**
   * Договор заключён с физическим лицом
   */
  B2C = "B2C",
  /**
   * Смешанная схема. Ростелеком работает с клиентом через партнёра
   */
  B2B2C = "B2B2C",
}
/**
 * Справочник типов договорных схем
 */
export type OfferTemplateApplicabilityRulesContractTypeResponseEnum = keyof typeof OfferTemplateApplicabilityRulesContractType
/**
 * Справочник типов договорных схем
 */
export type OfferTemplateApplicabilityRulesContractTypeRequestEnum = Exclude<OfferTemplateApplicabilityRulesContractTypeResponseEnum, "CONTRACT_TYPE_UNKNOWN">;

/**
 * Справочник типов минимального бесплатного пакета мобильного приложения
 */
export enum OfferTemplateApplicabilityRulesMobileAppPackageType {
  /**
   * Значение не указано
   */
  MOBILE_APP_PACKAGE_TYPE_UNKNOWN = "MOBILE_APP_PACKAGE_TYPE_UNKNOWN",
  /**
   * Кнопка открытия + Ключи
   */
  OPEN_DOOR_AND_KEYS = "OPEN_DOOR_AND_KEYS",
  /**
   * Кнопка открытия + Ключи + Аудиовызовы
   */
  OPEN_DOOR_AND_KEYS_AUDIO_CALLS = "OPEN_DOOR_AND_KEYS_AUDIO_CALLS",
  /**
   * Кнопка открытия + Ключи + Видеовызовы
   */
  OPEN_DOOR_AND_KEYS_VIDEO_CALLS = "OPEN_DOOR_AND_KEYS_VIDEO_CALLS",
}
/**
 * Справочник типов минимального бесплатного пакета мобильного приложения
 */
export type OfferTemplateApplicabilityRulesMobileAppPackageTypeResponseEnum = keyof typeof OfferTemplateApplicabilityRulesMobileAppPackageType
/**
 * Справочник типов минимального бесплатного пакета мобильного приложения
 */
export type OfferTemplateApplicabilityRulesMobileAppPackageTypeRequestEnum = Exclude<OfferTemplateApplicabilityRulesMobileAppPackageTypeResponseEnum, "MOBILE_APP_PACKAGE_TYPE_UNKNOWN">;

/**
 * Справочник типов договорной схемы устройства в квартире
 */
export enum OfferTemplateApplicabilityRulesRoomDeviceContractType {
  /**
   * Значение не указано
   */
  ROOM_DEVICE_CONTRACT_TYPE_UNKNOWN = "ROOM_DEVICE_CONTRACT_TYPE_UNKNOWN",
  /**
   * Житель заключает договор на квартирное устройство с внешней компанией
   */
  ROOM_DEVICE_B2B = "ROOM_DEVICE_B2B",
  /**
   * Житель заключает договор на квартирное устройство с Ростелекомом
   */
  ROOM_DEVICE_B2C = "ROOM_DEVICE_B2C",
}
/**
 * Справочник типов договорной схемы устройства в квартире
 */
export type OfferTemplateApplicabilityRulesRoomDeviceContractTypeResponseEnum = keyof typeof OfferTemplateApplicabilityRulesRoomDeviceContractType
/**
 * Справочник типов договорной схемы устройства в квартире
 */
export type OfferTemplateApplicabilityRulesRoomDeviceContractTypeRequestEnum = Exclude<OfferTemplateApplicabilityRulesRoomDeviceContractTypeResponseEnum, "ROOM_DEVICE_CONTRACT_TYPE_UNKNOWN">;

/**
 * Справочник типов сервисов
 */
export enum OfferTemplateServiceType {
  /**
   * Значение не указано
   */
  SERVICE_TYPE_UNKNOWN = "SERVICE_TYPE_UNKNOWN",
  /**
   * Умный домофон
   */
  INTERCOM = "INTERCOM",
  /**
   * Комплексное видеонаблюдение
   */
  CAMERAS = "CAMERAS",
  /**
   * Умные счётчики
   */
  TELEMETRY = "TELEMETRY",
  /**
   * Система контроля и управления доступом
   */
  ACCESS_CONTROL_PANEL = "ACCESS_CONTROL_PANEL",
  /**
   * Умный шлагбаум
   */
  BARRIER = "BARRIER",
}
/**
 * Справочник типов сервисов
 */
export type OfferTemplateServiceTypeResponseEnum = keyof typeof OfferTemplateServiceType
/**
 * Справочник типов сервисов
 */
export type OfferTemplateServiceTypeRequestEnum = Exclude<OfferTemplateServiceTypeResponseEnum, "SERVICE_TYPE_UNKNOWN">;

/**
 * Справочник статусов шаблона КВ
 */
export enum OfferTemplateStatusType {
  /**
   * Значение не указано
   */
  STATUS_TYPE_UNKNOWN = "STATUS_TYPE_UNKNOWN",
  /**
   * Активен
   */
  ACTIVE = "ACTIVE",
  /**
   * Архивирован
   */
  ARCHIVED = "ARCHIVED",
}
/**
 * Справочник статусов шаблона КВ
 */
export type OfferTemplateStatusTypeResponseEnum = keyof typeof OfferTemplateStatusType
/**
 * Справочник статусов шаблона КВ
 */
export type OfferTemplateStatusTypeRequestEnum = Exclude<OfferTemplateStatusTypeResponseEnum, "STATUS_TYPE_UNKNOWN">;

/**
 * Справочник типов направлений сортировки.
 */
export enum OfferTemplatePagingDirectionType {
  /**
   * Значение не указано
   */
  DIRECTION_TYPE_UNKNOWN = "DIRECTION_TYPE_UNKNOWN",
  /**
   * От большего к меньшему
   */
  DESC = "DESC",
  /**
   * От меньшего к большему
   */
  ASC = "ASC",
}
/**
 * Справочник типов направлений сортировки.
 */
export type OfferTemplatePagingDirectionTypeResponseEnum = keyof typeof OfferTemplatePagingDirectionType
/**
 * Справочник типов направлений сортировки.
 */
export type OfferTemplatePagingDirectionTypeRequestEnum = Exclude<OfferTemplatePagingDirectionTypeResponseEnum, "DIRECTION_TYPE_UNKNOWN">;

/**
 * Справочник типов значений сортировки.
 */
export enum OfferTemplatePagingOrderByType {
  /**
   * Значение не указано
   */
  ORDER_BY_TYPE_UNKNOWN = "ORDER_BY_TYPE_UNKNOWN",
  /**
   * По дате создания
   */
  CREATED_AT = "CREATED_AT",
  /**
   * По наименованию
   */
  TITLE = "TITLE",
}
/**
 * Справочник типов значений сортировки.
 */
export type OfferTemplatePagingOrderByTypeResponseEnum = keyof typeof OfferTemplatePagingOrderByType
/**
 * Справочник типов значений сортировки.
 */
export type OfferTemplatePagingOrderByTypeRequestEnum = Exclude<OfferTemplatePagingOrderByTypeResponseEnum, "ORDER_BY_TYPE_UNKNOWN">;

/**
 * Запрос архивации шаблона КВ
 */
export type DeleteOfferTemplateRequestDto = {
  /**
   * Идентификатор шаблона КВ.
   * Тип: Guid
   */
  id: string
}
/**
 * Ответ на запрос архивации шаблона КВ
 */
export type DeleteOfferTemplateResponseDto = {
}
/**
 * Запрос получения количества Шаблонов КВ по ОРПОН дома
 */
export type GetOfferTemplateByOrponCountRequestDto = {
  /**
   * ОРПОН. Идентификатор дома
   */
  orpon: string
}
/**
 * Ответ на запрос получения количества Шаблонов КВ по ОРПОН дома
 */
export type GetOfferTemplateByOrponCountResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Всего шаблонов КВ
   */
  readonly data: number
  /**
   * Ошибка
   */
  readonly error: GetOfferTemplateByOrponCountResponseErrorDto
}>
/**
 * Ошибка запроса
 */
export type GetOfferTemplateByOrponCountResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: ValidationErrorRequestDto
}>
/**
 * Ошибка запроса
 */
export type GetOfferTemplateByOrponCountResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: ValidationErrorResponseDto
}>
/**
 * Запрос получения списка Шаблонов КВ по ОРПОН дома
 */
export type GetOfferTemplateByOrponListRequestDto = {
  /**
   * ОРПОН. Идентификатор дома
   */
  orpon: string
}
/**
 * Ответ на запрос получения списка Шаблонов КВ по ОРПОН дома
 */
export type GetOfferTemplateByOrponListResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Шаблон КВ
   */
  readonly data: OfferTemplateResponseDto
  /**
   * Ошибка
   */
  readonly error: GetOfferTemplateByOrponListResponseErrorDto
}>
/**
 * Ошибка запроса
 */
export type GetOfferTemplateByOrponListResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: ValidationErrorRequestDto
}>
/**
 * Ошибка запроса
 */
export type GetOfferTemplateByOrponListResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: ValidationErrorResponseDto
}>
/**
 * Запрос получения количества шаблонов КВ
 */
export type GetOfferTemplateCountRequestDto = {
  /**
   * Фильтр
   */
  filter?: OfferTemplateFilterRequestDto | null
}
/**
 * Ответ на запрос получения количества шаблонов КВ
 */
export type GetOfferTemplateCountResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Всего шаблонов КВ
   */
  readonly data: number
  /**
   * Ошибка
   */
  readonly error: GetOfferTemplateCountResponseErrorDto
}>
/**
 * Ошибка запроса получения количества шаблонов КВ
 */
export type GetOfferTemplateCountResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: ValidationErrorRequestDto
}>
/**
 * Ошибка запроса получения количества шаблонов КВ
 */
export type GetOfferTemplateCountResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: ValidationErrorResponseDto
}>
/**
 * Запрос получения списка шаблонов КВ
 */
export type GetOfferTemplateListRequestDto = {
  /**
   * Фильтр
   */
  filter?: OfferTemplateFilterRequestDto | null
}
/**
 * pagination
 */
& fm.OptionalOneOf<{
  /**
   * Пагинация
   */
  readonly paging: OfferTemplatePagingRequestDto
}>
/**
 * Ответ на запрос получения списка шаблонов КВ
 */
export type GetOfferTemplateListResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Шаблон КВ
   */
  readonly data: OfferTemplateResponseDto
  /**
   * Ошибка
   */
  readonly error: GetOfferTemplateListResponseErrorDto
}>
/**
 * Ошибка запроса получения списка шаблонов КВ
 */
export type GetOfferTemplateListResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: ValidationErrorRequestDto
}>
/**
 * Ошибка запроса получения списка шаблонов КВ
 */
export type GetOfferTemplateListResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: ValidationErrorResponseDto
}>
/**
 * Запрос получения шаблона КВ
 */
export type GetOfferTemplateRequestDto = {
  /**
   * Идентификатор шаблона КВ.
   * Тип: Guid
   */
  id: string
}
/**
 * Ответ на запрос получения шаблона КВ
 */
export type GetOfferTemplateResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Шаблон КВ
   */
  readonly data: OfferTemplateResponseDto
}>
/**
 * Шаблон КВ
 */
export type OfferTemplateRequestDto = {
  /**
   * Идентификатор.
   * # Тип: Guid
   */
  id?: string
  /**
   * Тип сервиса
   */
  serviceType: OfferTemplateServiceTypeRequestEnum
  /**
   * Наименование КВ.
   * # Диапазон: 3..256
   */
  title: string
  /**
   * Описание КВ.
   * # Диапазон: 3..1024
   */
  description?: string | null
  /**
   * Правила применимости Шаблона КВ
   */
  applicabilityRules: OfferTemplateApplicabilityRulesRequestDto
  /**
   * Список элементов Шаблона КВ.
   * Каждый элемент описывает технологический план и параметры создания КВ для него
   */
  items: OfferTemplateItemRequestDto[]
}
/**
 * Шаблон КВ
 */
export type OfferTemplateResponseDto = {
  /**
   * Идентификатор.
   * # Тип: Guid
   */
  id: string
  /**
   * Тип сервиса
   */
  serviceType: OfferTemplateServiceTypeResponseEnum
  /**
   * Наименование КВ.
   * # Диапазон: 3..256
   */
  title: string
  /**
   * Описание КВ.
   * # Диапазон: 3..1024
   */
  description: string | null
  /**
   * Статус шаблона КВ.
   * Заполняется сервером
   */
  readonly statusType: OfferTemplateStatusTypeResponseEnum
  /**
   * Правила применимости Шаблона КВ
   */
  applicabilityRules: OfferTemplateApplicabilityRulesResponseDto
  /**
   * Список элементов Шаблона КВ.
   * Каждый элемент описывает технологический план и параметры создания КВ для него
   */
  items: OfferTemplateItemResponseDto[]
  /**
   * Дата и время создания.
   * Заполняется сервером.
   * # Тип: DateTime
   */
  readonly createdAt: string
  /**
   * Дата и время последнего изменения.
   * Заполняется и обновляется сервером.
   * Является версией объекта.
   * # Тип: DateTime
   */
  readonly updatedAt: string | null
}
/**
 * Правила применимости Шаблона КВ
 */
export type OfferTemplateApplicabilityRulesRequestDto = {
  /**
   * Ограничение по регионам.
   * # Диапазон: 0..100
   */
  rfIds?: number[]
  /**
   * Договорная схема
   */
  contractType?: OfferTemplateApplicabilityRulesContractTypeRequestEnum | "CONTRACT_TYPE_UNKNOWN"
  /**
   * Тип клиента.
   * Заполняется только когда contract_type принимает одно из значений: B2B, B2B2C
   */
  clientType?: OfferTemplateApplicabilityRulesClientTypeRequestEnum | "CLIENT_TYPE_UNKNOWN"
  /**
   * Биллинговая система.
   * Заполняется только когда contract_type принимает одно из значений: B2B, B2B2C
   */
  billingSystemType?: OfferTemplateApplicabilityRulesBillingSystemTypeRequestEnum | "BILLING_SYSTEM_TYPE_UNKNOWN"
  /**
   * Принимаются ли платежи за умный домофон на счёт внешней компании
   */
  isExternalPaymentForSmartIntercom?: boolean
  /**
   * Аналоговые трубки устанавливаются в квартирах объекта
   */
  isCmsPhone?: boolean
  /**
   * SIP-трубки устанавливаются в квартирах объекта
   */
  isSipPhone?: boolean
  /**
   * Видеомониторы устанавливаются в квартирах объекта
   */
  isVideoMonitor?: boolean
  /**
   * Тип договорной схемы устройства в квартире
   */
  roomDeviceContractType?: OfferTemplateApplicabilityRulesRoomDeviceContractTypeRequestEnum | "ROOM_DEVICE_CONTRACT_TYPE_UNKNOWN"
  /**
   * Минимальный бесплатный пакет мобильного приложения
   */
  mobileAppPackageType?: OfferTemplateApplicabilityRulesMobileAppPackageTypeRequestEnum | "MOBILE_APP_PACKAGE_TYPE_UNKNOWN"
  /**
   * Переадресация на городские/мобильные номера
   */
  isCallForwardingEnabled?: boolean
  /**
   * Цифровой клиентский путь
   */
  isDigitalWay?: boolean
}
/**
 * Правила применимости Шаблона КВ
 */
export type OfferTemplateApplicabilityRulesResponseDto = {
  /**
   * Ограничение по регионам.
   * # Диапазон: 0..100
   */
  rfIds: number[]
  /**
   * Договорная схема
   */
  contractType: OfferTemplateApplicabilityRulesContractTypeResponseEnum
  /**
   * Тип клиента.
   * Заполняется только когда contract_type принимает одно из значений: B2B, B2B2C
   */
  clientType: OfferTemplateApplicabilityRulesClientTypeResponseEnum
  /**
   * Биллинговая система.
   * Заполняется только когда contract_type принимает одно из значений: B2B, B2B2C
   */
  billingSystemType: OfferTemplateApplicabilityRulesBillingSystemTypeResponseEnum
  /**
   * Принимаются ли платежи за умный домофон на счёт внешней компании
   */
  isExternalPaymentForSmartIntercom: boolean
  /**
   * Аналоговые трубки устанавливаются в квартирах объекта
   */
  isCmsPhone: boolean
  /**
   * SIP-трубки устанавливаются в квартирах объекта
   */
  isSipPhone: boolean
  /**
   * Видеомониторы устанавливаются в квартирах объекта
   */
  isVideoMonitor: boolean
  /**
   * Тип договорной схемы устройства в квартире
   */
  roomDeviceContractType: OfferTemplateApplicabilityRulesRoomDeviceContractTypeResponseEnum
  /**
   * Минимальный бесплатный пакет мобильного приложения
   */
  mobileAppPackageType: OfferTemplateApplicabilityRulesMobileAppPackageTypeResponseEnum
  /**
   * Переадресация на городские/мобильные номера
   */
  isCallForwardingEnabled: boolean
  /**
   * Цифровой клиентский путь
   */
  isDigitalWay: boolean
}
/**
 * Элемент Шаблона КВ
 */
export type OfferTemplateItemRequestDto = {
  /**
   * Идентификатор технологического плана.
   * # Диапазон: 1..2147483647
   */
  planId: number
  /**
   * Тип коммерческой возможности
   */
  type: offerV1.OfferTypeRequestEnum
  /**
   * Подключать ли автоматическую подписку
   */
  isEnableAutoSubscribe?: boolean
  /**
   * Признак принадлежности к цифровому клиентскому пути
   */
  isDigitalWay?: boolean
  /**
   * Адрес размещения офферты.
   * Полный url до файла.
   * # Диапазон: 0..2048
   */
  offerUrl?: string | null
}
/**
 * Элемент Шаблона КВ
 */
export type OfferTemplateItemResponseDto = {
  /**
   * Идентификатор технологического плана.
   * # Диапазон: 1..2147483647
   */
  planId: number
  /**
   * Тип коммерческой возможности
   */
  type: offerV1.OfferTypeResponseEnum
  /**
   * Подключать ли автоматическую подписку
   */
  isEnableAutoSubscribe: boolean
  /**
   * Признак принадлежности к цифровому клиентскому пути
   */
  isDigitalWay: boolean
  /**
   * Адрес размещения офферты.
   * Полный url до файла.
   * # Диапазон: 0..2048
   */
  offerUrl: string | null
}
/**
 * Ошибка сохранения.
 * Эти проверки выполняются при работе с базой данных и сторонними сервисами
 */
export type OfferTemplateSavingErrorRequestDto = {
}
/**
 * reason
 */
& fm.OptionalOneOf<{
  /**
   * Конфликт версий
   */
  readonly conflict: OfferTemplateSavingErrorConflictRequestDto
  /**
   * Дублирование шаблона
   */
  readonly duplicateTemplate: OfferTemplateSavingErrorDuplicateTemplateRequestDto
}>
/**
 * Ошибка сохранения.
 * Эти проверки выполняются при работе с базой данных и сторонними сервисами
 */
export type OfferTemplateSavingErrorResponseDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Конфликт версий
   */
  readonly conflict: OfferTemplateSavingErrorConflictResponseDto
  /**
   * Дублирование шаблона
   */
  readonly duplicateTemplate: OfferTemplateSavingErrorDuplicateTemplateResponseDto
}>
/**
 * Конфликт версий.
 * Причины:
 * - В базе хранится другая версия строки, значения updated_at отличаются
 */
export type OfferTemplateSavingErrorConflictRequestDto = {
}
/**
 * Конфликт версий.
 * Причины:
 * - В базе хранится другая версия строки, значения updated_at отличаются
 */
export type OfferTemplateSavingErrorConflictResponseDto = {
}
/**
 * Шаблон с таким типом сервиса и правилами применимости уже существует.
 * Нельзя создать два или более шаблона с одинаковым типом сервиса и одинаковыми правилами применимости
 */
export type OfferTemplateSavingErrorDuplicateTemplateRequestDto = {
}
/**
 * Шаблон с таким типом сервиса и правилами применимости уже существует.
 * Нельзя создать два или более шаблона с одинаковым типом сервиса и одинаковыми правилами применимости
 */
export type OfferTemplateSavingErrorDuplicateTemplateResponseDto = {
}
/**
 * Фильтр по шаблонам КВ
 */
export type OfferTemplateFilterRequestDto = {
  /**
   * По статусам
   */
  statusTypes?: OfferTemplateStatusTypeResponseEnum[]
  /**
   * По типам сервисов
   */
  serviceTypes?: OfferTemplateServiceTypeResponseEnum[]
  /**
   * По идентификаторам регионов (из правил применимости)
   */
  rfIds?: number[]
  /**
   * По тексту.
   * Если значение не передано, поиск по нему не производится.
   * # Диапазон: 3..64.
   * # Поиск производится по полям:
   * # - Наименование;
   * # - Описание
   */
  text?: string | null
  /**
   * По типам договорных схем (из правил применимости)
   */
  applicabilityRulesContractTypes?: OfferTemplateApplicabilityRulesContractTypeResponseEnum[]
  /**
   * По типам клиентов (из правил применимости)
   */
  applicabilityRulesClientTypes?: OfferTemplateApplicabilityRulesClientTypeResponseEnum[]
  /**
   * По типам биллинговых систем (из правил применимости)
   */
  applicabilityRulesBillingSystemTypes?: OfferTemplateApplicabilityRulesBillingSystemTypeResponseEnum[]
  /**
   * По признаку внешней оплаты умного домофона (из правил применимости)
   */
  isExternalPaymentForSmartIntercom?: boolean | null
  /**
   * По наличию CMS телефона в квартире (из правил применимости)
   */
  applicabilityRulesIsCmsPhone?: boolean | null
  /**
   * По наличию SIP телефона в квартире (из правил применимости)
   */
  applicabilityRulesIsSipPhone?: boolean | null
  /**
   * По наличию видеомонитора в квартире (из правил применимости)
   */
  applicabilityRulesIsVideoMonitor?: boolean | null
  /**
   * По типам договорной схемы устройства в квартире (из правил применимости)
   */
  applicabilityRulesRoomDeviceContractTypes?: OfferTemplateApplicabilityRulesRoomDeviceContractTypeResponseEnum[]
  /**
   * По типам минимального бесплатного пакета мобильного приложения (из правил применимости)
   */
  applicabilityRulesMobileAppPackageTypes?: OfferTemplateApplicabilityRulesMobileAppPackageTypeResponseEnum[]
  /**
   * По признаку переадресации на городские/мобильные номера (из правил применимости)
   */
  isCallForwardingEnabled?: boolean | null
  /**
   * По признаку цифрового клиентского пути (из правил применимости)
   */
  isDigitalWay?: boolean | null
  /**
   * По идентификаторам технологических планов (из элементов шаблона)
   */
  planIds?: number[]
}
/**
 * Фильтр по шаблонам КВ
 */
export type OfferTemplateFilterResponseDto = {
  /**
   * По статусам
   */
  statusTypes: OfferTemplateStatusTypeResponseEnum[]
  /**
   * По типам сервисов
   */
  serviceTypes: OfferTemplateServiceTypeResponseEnum[]
  /**
   * По идентификаторам регионов (из правил применимости)
   */
  rfIds: number[]
  /**
   * По тексту.
   * Если значение не передано, поиск по нему не производится.
   * # Диапазон: 3..64.
   * # Поиск производится по полям:
   * # - Наименование;
   * # - Описание
   */
  text: string | null
  /**
   * По типам договорных схем (из правил применимости)
   */
  applicabilityRulesContractTypes: OfferTemplateApplicabilityRulesContractTypeResponseEnum[]
  /**
   * По типам клиентов (из правил применимости)
   */
  applicabilityRulesClientTypes: OfferTemplateApplicabilityRulesClientTypeResponseEnum[]
  /**
   * По типам биллинговых систем (из правил применимости)
   */
  applicabilityRulesBillingSystemTypes: OfferTemplateApplicabilityRulesBillingSystemTypeResponseEnum[]
  /**
   * По признаку внешней оплаты умного домофона (из правил применимости)
   */
  isExternalPaymentForSmartIntercom: boolean | null
  /**
   * По наличию CMS телефона в квартире (из правил применимости)
   */
  applicabilityRulesIsCmsPhone: boolean | null
  /**
   * По наличию SIP телефона в квартире (из правил применимости)
   */
  applicabilityRulesIsSipPhone: boolean | null
  /**
   * По наличию видеомонитора в квартире (из правил применимости)
   */
  applicabilityRulesIsVideoMonitor: boolean | null
  /**
   * По типам договорной схемы устройства в квартире (из правил применимости)
   */
  applicabilityRulesRoomDeviceContractTypes: OfferTemplateApplicabilityRulesRoomDeviceContractTypeResponseEnum[]
  /**
   * По типам минимального бесплатного пакета мобильного приложения (из правил применимости)
   */
  applicabilityRulesMobileAppPackageTypes: OfferTemplateApplicabilityRulesMobileAppPackageTypeResponseEnum[]
  /**
   * По признаку переадресации на городские/мобильные номера (из правил применимости)
   */
  isCallForwardingEnabled: boolean | null
  /**
   * По признаку цифрового клиентского пути (из правил применимости)
   */
  isDigitalWay: boolean | null
  /**
   * По идентификаторам технологических планов (из элементов шаблона)
   */
  planIds: number[]
}
/**
 * Пагинация по шаблонам КВ
 */
export type OfferTemplatePagingRequestDto = {
  /**
   * Тип значения сортировки.
   * Если значение не передано, то будет взято значение по умолчанию.
   * # По умолчанию: CREATED_AT
   */
  orderByType?: OfferTemplatePagingOrderByTypeRequestEnum | "ORDER_BY_TYPE_UNKNOWN"
  /**
   * Тип направления сортировки.
   * # По умолчанию: DESC
   */
  directionType?: OfferTemplatePagingDirectionTypeRequestEnum | "DIRECTION_TYPE_UNKNOWN"
  /**
   * Количество записей на страницу.
   * Если значение 0 (не передано), то будет взято значение по умолчанию.
   * # Диапазон: 0..100.
   * # По умолчанию: 20
   */
  limit?: number
  /**
   * Сдвиг.
   * # Диапазон: 0..2147483647
   */
  offset?: number
}
/**
 * Пагинация по шаблонам КВ
 */
export type OfferTemplatePagingResponseDto = {
  /**
   * Тип значения сортировки.
   * Если значение не передано, то будет взято значение по умолчанию.
   * # По умолчанию: CREATED_AT
   */
  orderByType: OfferTemplatePagingOrderByTypeResponseEnum
  /**
   * Тип направления сортировки.
   * # По умолчанию: DESC
   */
  directionType: OfferTemplatePagingDirectionTypeResponseEnum
  /**
   * Количество записей на страницу.
   * Если значение 0 (не передано), то будет взято значение по умолчанию.
   * # Диапазон: 0..100.
   * # По умолчанию: 20
   */
  limit: number
  /**
   * Сдвиг.
   * # Диапазон: 0..2147483647
   */
  offset: number
}
/**
 * Запрос создания/редактирования шаблона КВ
 */
export type PostOfferTemplateRequestDto = {
  /**
   * Шаблон КВ.
   * Если id не передан — создаётся новый шаблон.
   * Если id передан — редактируется существующий шаблон
   */
  data: OfferTemplateRequestDto
}
/**
 * Ответ на запрос создания/редактирования шаблона КВ
 */
export type PostOfferTemplateResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Шаблон КВ
   */
  readonly data: OfferTemplateResponseDto
  /**
   * Ошибка
   */
  readonly error: PostOfferTemplateResponseErrorDto
}>
/**
 * Ошибка запроса сохранения шаблона КВ
 */
export type PostOfferTemplateResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: ValidationErrorRequestDto
  /**
   * Ошибка сохранения
   */
  readonly saving: OfferTemplateSavingErrorRequestDto
}>
/**
 * Ошибка запроса сохранения шаблона КВ
 */
export type PostOfferTemplateResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: ValidationErrorResponseDto
  /**
   * Ошибка сохранения
   */
  readonly saving: OfferTemplateSavingErrorResponseDto
}>
/**
 * Запрос восстановления шаблона КВ из архива
 */
export type PostOfferTemplateRestoreRequestDto = {
  /**
   * Идентификатор шаблона КВ.
   * Тип: Guid
   */
  id: string
}
/**
 * Ответ на запрос восстановления шаблона КВ из архива
 */
export type PostOfferTemplateRestoreResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Восстановленный шаблон КВ
   */
  readonly data: OfferTemplateResponseDto
}>
/**
 * Ошибки валидации.
 * Эти проверки выполняются до обращения в базу данных
 */
export type ValidationErrorRequestDto = {
  /**
   * Путь к полю в формате наименования прото
   */
  path: string
  /**
   * Валидационное сообщение
   */
  message: string
}
/**
 * Ошибки валидации.
 * Эти проверки выполняются до обращения в базу данных
 */
export type ValidationErrorResponseDto = {
  /**
   * Путь к полю в формате наименования прото
   */
  path: string
  /**
   * Валидационное сообщение
   */
  message: string
}
/**
 * Дескриптор
 */
export const descriptor = {
  /**
   * Запрос архивации шаблона КВ
   */
  "DeleteOfferTemplateRequest": {
    "kind": "class",
    "text": "Запрос архивации шаблона КВ",
    "fields": {
      /**
       * Идентификатор шаблона КВ.
       * Тип: Guid
       */
      "id": {
        "type": "string",
        "text": "Идентификатор шаблона КВ.\nТип: Guid",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Ответ на запрос архивации шаблона КВ
   */
  "DeleteOfferTemplateResponse": {
    "kind": "class",
    "text": "Ответ на запрос архивации шаблона КВ",
  },
  /**
   * Запрос получения количества Шаблонов КВ по ОРПОН дома
   */
  "GetOfferTemplateByOrponCountRequest": {
    "kind": "class",
    "text": "Запрос получения количества Шаблонов КВ по ОРПОН дома",
    "fields": {
      /**
       * ОРПОН. Идентификатор дома
       */
      "orpon": {
        "type": "int64",
        "text": "ОРПОН. Идентификатор дома",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Ответ на запрос получения количества Шаблонов КВ по ОРПОН дома
   */
  "GetOfferTemplateByOrponCountResponse": {
    "kind": "class",
    "text": "Ответ на запрос получения количества Шаблонов КВ по ОРПОН дома",
    "fields": {
      /**
       * Всего шаблонов КВ
       */
      "data": {
        "type": "int32",
        "text": "Всего шаблонов КВ",
      },
      /**
       * Ошибка
       */
      "error": {
        "type": "GetOfferTemplateByOrponCountResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка запроса
   */
  "GetOfferTemplateByOrponCountResponse.Error": {
    "kind": "class",
    "text": "Ошибка запроса",
    "fields": {
      /**
       * Ошибка валидации
       */
      "validation": {
        "type": "ValidationError",
        "text": "Ошибка валидации",
      },
    },
  },
  /**
   * Запрос получения списка Шаблонов КВ по ОРПОН дома
   */
  "GetOfferTemplateByOrponListRequest": {
    "kind": "class",
    "text": "Запрос получения списка Шаблонов КВ по ОРПОН дома",
    "fields": {
      /**
       * ОРПОН. Идентификатор дома
       */
      "orpon": {
        "type": "int64",
        "text": "ОРПОН. Идентификатор дома",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Ответ на запрос получения списка Шаблонов КВ по ОРПОН дома
   */
  "GetOfferTemplateByOrponListResponse": {
    "kind": "class",
    "text": "Ответ на запрос получения списка Шаблонов КВ по ОРПОН дома",
    "fields": {
      /**
       * Шаблон КВ
       */
      "data": {
        "type": "OfferTemplate",
        "text": "Шаблон КВ",
      },
      /**
       * Ошибка
       */
      "error": {
        "type": "GetOfferTemplateByOrponListResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка запроса
   */
  "GetOfferTemplateByOrponListResponse.Error": {
    "kind": "class",
    "text": "Ошибка запроса",
    "fields": {
      /**
       * Ошибка валидации
       */
      "validation": {
        "type": "ValidationError",
        "text": "Ошибка валидации",
      },
    },
  },
  /**
   * Запрос получения количества шаблонов КВ
   */
  "GetOfferTemplateCountRequest": {
    "kind": "class",
    "text": "Запрос получения количества шаблонов КВ",
    "fields": {
      /**
       * Фильтр
       */
      "filter": {
        "type": "OfferTemplateFilter",
        "text": "Фильтр",
      },
    },
  },
  /**
   * Ответ на запрос получения количества шаблонов КВ
   */
  "GetOfferTemplateCountResponse": {
    "kind": "class",
    "text": "Ответ на запрос получения количества шаблонов КВ",
    "fields": {
      /**
       * Всего шаблонов КВ
       */
      "data": {
        "type": "int32",
        "text": "Всего шаблонов КВ",
      },
      /**
       * Ошибка
       */
      "error": {
        "type": "GetOfferTemplateCountResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка запроса получения количества шаблонов КВ
   */
  "GetOfferTemplateCountResponse.Error": {
    "kind": "class",
    "text": "Ошибка запроса получения количества шаблонов КВ",
    "fields": {
      /**
       * Ошибка валидации
       */
      "validation": {
        "type": "ValidationError",
        "text": "Ошибка валидации",
      },
    },
  },
  /**
   * Запрос получения списка шаблонов КВ
   */
  "GetOfferTemplateListRequest": {
    "kind": "class",
    "text": "Запрос получения списка шаблонов КВ",
    "fields": {
      /**
       * Фильтр
       */
      "filter": {
        "type": "OfferTemplateFilter",
        "text": "Фильтр",
      },
      /**
       * Пагинация
       */
      "paging": {
        "type": "OfferTemplatePaging",
        "text": "Пагинация",
      },
    },
  },
  /**
   * Ответ на запрос получения списка шаблонов КВ
   */
  "GetOfferTemplateListResponse": {
    "kind": "class",
    "text": "Ответ на запрос получения списка шаблонов КВ",
    "fields": {
      /**
       * Шаблон КВ
       */
      "data": {
        "type": "OfferTemplate",
        "text": "Шаблон КВ",
      },
      /**
       * Ошибка
       */
      "error": {
        "type": "GetOfferTemplateListResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка запроса получения списка шаблонов КВ
   */
  "GetOfferTemplateListResponse.Error": {
    "kind": "class",
    "text": "Ошибка запроса получения списка шаблонов КВ",
    "fields": {
      /**
       * Ошибка валидации
       */
      "validation": {
        "type": "ValidationError",
        "text": "Ошибка валидации",
      },
    },
  },
  /**
   * Запрос получения шаблона КВ
   */
  "GetOfferTemplateRequest": {
    "kind": "class",
    "text": "Запрос получения шаблона КВ",
    "fields": {
      /**
       * Идентификатор шаблона КВ.
       * Тип: Guid
       */
      "id": {
        "type": "string",
        "text": "Идентификатор шаблона КВ.\nТип: Guid",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Ответ на запрос получения шаблона КВ
   */
  "GetOfferTemplateResponse": {
    "kind": "class",
    "text": "Ответ на запрос получения шаблона КВ",
    "fields": {
      /**
       * Шаблон КВ
       */
      "data": {
        "type": "OfferTemplate",
        "text": "Шаблон КВ",
      },
    },
  },
  /**
   * Шаблон КВ
   */
  "OfferTemplate": {
    "kind": "class",
    "text": "Шаблон КВ",
    "fields": {
      /**
       * Идентификатор.
       * # Тип: Guid
       */
      "id": {
        "type": "string",
        "text": "Идентификатор.\n# Тип: Guid",
      },
      /**
       * Тип сервиса
       */
      "serviceType": {
        "type": "OfferTemplate.ServiceType",
        "text": "Тип сервиса",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Наименование КВ.
       * # Диапазон: 3..256
       */
      "title": {
        "type": "string",
        "text": "Наименование КВ.\n# Диапазон: 3..256",
        "rules": {
          "required": "Значение обязательно для заполнения",
          "minLength": {
            "value": 3,
            "message": "Значение не входит в допустимый диапазон. Минимум: 3"
          },
          "maxLength": {
            "value": 256,
            "message": "Значение не входит в допустимый диапазон. Максимум: 256"
          },
        }
      },
      /**
       * Описание КВ.
       * # Диапазон: 3..1024
       */
      "description": {
        "type": "google.protobuf.StringValue",
        "text": "Описание КВ.\n# Диапазон: 3..1024",
        "rules": {
          "minLength": {
            "value": 3,
            "message": "Значение не входит в допустимый диапазон. Минимум: 3"
          },
          "maxLength": {
            "value": 1024,
            "message": "Значение не входит в допустимый диапазон. Максимум: 1024"
          },
        }
      },
      /**
       * Статус шаблона КВ.
       * Заполняется сервером
       */
      "statusType": {
        "type": "OfferTemplate.StatusType",
        "text": "Статус шаблона КВ.\nЗаполняется сервером",
      },
      /**
       * Правила применимости Шаблона КВ
       */
      "applicabilityRules": {
        "type": "OfferTemplate.ApplicabilityRules",
        "text": "Правила применимости Шаблона КВ",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Список элементов Шаблона КВ.
       * Каждый элемент описывает технологический план и параметры создания КВ для него
       */
      "items": {
        "type": "OfferTemplate.Item",
        "text": "Список элементов Шаблона КВ.\nКаждый элемент описывает технологический план и параметры создания КВ для него",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Дата и время создания.
       * Заполняется сервером.
       * # Тип: DateTime
       */
      "createdAt": {
        "type": "google.protobuf.Timestamp",
        "text": "Дата и время создания.\nЗаполняется сервером.\n# Тип: DateTime",
      },
      /**
       * Дата и время последнего изменения.
       * Заполняется и обновляется сервером.
       * Является версией объекта.
       * # Тип: DateTime
       */
      "updatedAt": {
        "type": "google.protobuf.Timestamp",
        "text": "Дата и время последнего изменения.\nЗаполняется и обновляется сервером.\nЯвляется версией объекта.\n# Тип: DateTime",
      },
    },
  },
  /**
   * Правила применимости Шаблона КВ
   */
  "OfferTemplate.ApplicabilityRules": {
    "kind": "class",
    "text": "Правила применимости Шаблона КВ",
    "fields": {
      /**
       * Ограничение по регионам.
       * # Диапазон: 0..100
       */
      "rfIds": {
        "type": "int32",
        "text": "Ограничение по регионам.\n# Диапазон: 0..100",
        "rules": {
          "min": {
            "value": 0,
            "message": "Значение не входит в допустимый диапазон. Минимум: 0"
          },
          "max": {
            "value": 100,
            "message": "Значение не входит в допустимый диапазон. Максимум: 100"
          },
        }
      },
      /**
       * Договорная схема
       */
      "contractType": {
        "type": "OfferTemplate.ApplicabilityRules.ContractType",
        "text": "Договорная схема",
      },
      /**
       * Тип клиента.
       * Заполняется только когда contract_type принимает одно из значений: B2B, B2B2C
       */
      "clientType": {
        "type": "OfferTemplate.ApplicabilityRules.ClientType",
        "text": "Тип клиента.\nЗаполняется только когда contract_type принимает одно из значений: B2B, B2B2C",
      },
      /**
       * Биллинговая система.
       * Заполняется только когда contract_type принимает одно из значений: B2B, B2B2C
       */
      "billingSystemType": {
        "type": "OfferTemplate.ApplicabilityRules.BillingSystemType",
        "text": "Биллинговая система.\nЗаполняется только когда contract_type принимает одно из значений: B2B, B2B2C",
      },
      /**
       * Принимаются ли платежи за умный домофон на счёт внешней компании
       */
      "isExternalPaymentForSmartIntercom": {
        "type": "bool",
        "text": "Принимаются ли платежи за умный домофон на счёт внешней компании",
      },
      /**
       * Аналоговые трубки устанавливаются в квартирах объекта
       */
      "isCmsPhone": {
        "type": "bool",
        "text": "Аналоговые трубки устанавливаются в квартирах объекта",
      },
      /**
       * SIP-трубки устанавливаются в квартирах объекта
       */
      "isSipPhone": {
        "type": "bool",
        "text": "SIP-трубки устанавливаются в квартирах объекта",
      },
      /**
       * Видеомониторы устанавливаются в квартирах объекта
       */
      "isVideoMonitor": {
        "type": "bool",
        "text": "Видеомониторы устанавливаются в квартирах объекта",
      },
      /**
       * Тип договорной схемы устройства в квартире
       */
      "roomDeviceContractType": {
        "type": "OfferTemplate.ApplicabilityRules.RoomDeviceContractType",
        "text": "Тип договорной схемы устройства в квартире",
      },
      /**
       * Минимальный бесплатный пакет мобильного приложения
       */
      "mobileAppPackageType": {
        "type": "OfferTemplate.ApplicabilityRules.MobileAppPackageType",
        "text": "Минимальный бесплатный пакет мобильного приложения",
      },
      /**
       * Переадресация на городские/мобильные номера
       */
      "isCallForwardingEnabled": {
        "type": "bool",
        "text": "Переадресация на городские/мобильные номера",
      },
      /**
       * Цифровой клиентский путь
       */
      "isDigitalWay": {
        "type": "bool",
        "text": "Цифровой клиентский путь",
      },
    },
  },
  /**
   * Элемент Шаблона КВ
   */
  "OfferTemplate.Item": {
    "kind": "class",
    "text": "Элемент Шаблона КВ",
    "fields": {
      /**
       * Идентификатор технологического плана.
       * # Диапазон: 1..2147483647
       */
      "planId": {
        "type": "int32",
        "text": "Идентификатор технологического плана.\n# Диапазон: 1..2147483647",
        "rules": {
          "required": "Значение обязательно для заполнения",
          "min": {
            "value": 1,
            "message": "Значение не входит в допустимый диапазон. Минимум: 1"
          },
          "max": {
            "value": 2147483647,
            "message": "Значение не входит в допустимый диапазон. Максимум: 2147483647"
          },
        }
      },
      /**
       * Тип коммерческой возможности
       */
      "type": {
        "type": "Offer.Type",
        "text": "Тип коммерческой возможности",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Подключать ли автоматическую подписку
       */
      "isEnableAutoSubscribe": {
        "type": "bool",
        "text": "Подключать ли автоматическую подписку",
      },
      /**
       * Признак принадлежности к цифровому клиентскому пути
       */
      "isDigitalWay": {
        "type": "bool",
        "text": "Признак принадлежности к цифровому клиентскому пути",
      },
      /**
       * Адрес размещения офферты.
       * Полный url до файла.
       * # Диапазон: 0..2048
       */
      "offerUrl": {
        "type": "google.protobuf.StringValue",
        "text": "Адрес размещения офферты.\nПолный url до файла.\n# Диапазон: 0..2048",
        "rules": {
          "minLength": {
            "value": 0,
            "message": "Значение не входит в допустимый диапазон. Минимум: 0"
          },
          "maxLength": {
            "value": 2048,
            "message": "Значение не входит в допустимый диапазон. Максимум: 2048"
          },
        }
      },
    },
  },
  /**
   * Ошибка сохранения.
   * Эти проверки выполняются при работе с базой данных и сторонними сервисами
   */
  "OfferTemplate.SavingError": {
    "kind": "class",
    "text": "Ошибка сохранения.\nЭти проверки выполняются при работе с базой данных и сторонними сервисами",
    "fields": {
      /**
       * Конфликт версий
       */
      "conflict": {
        "type": "OfferTemplate.SavingError.Conflict",
        "text": "Конфликт версий",
      },
      /**
       * Дублирование шаблона
       */
      "duplicateTemplate": {
        "type": "OfferTemplate.SavingError.DuplicateTemplate",
        "text": "Дублирование шаблона",
      },
    },
  },
  /**
   * Конфликт версий.
   * Причины:
   * - В базе хранится другая версия строки, значения updated_at отличаются
   */
  "OfferTemplate.SavingError.Conflict": {
    "kind": "class",
    "text": "Конфликт версий.\nПричины:\n- В базе хранится другая версия строки, значения updated_at отличаются",
  },
  /**
   * Шаблон с таким типом сервиса и правилами применимости уже существует.
   * Нельзя создать два или более шаблона с одинаковым типом сервиса и одинаковыми правилами применимости
   */
  "OfferTemplate.SavingError.DuplicateTemplate": {
    "kind": "class",
    "text": "Шаблон с таким типом сервиса и правилами применимости уже существует.\nНельзя создать два или более шаблона с одинаковым типом сервиса и одинаковыми правилами применимости",
  },
  /**
   * Фильтр по шаблонам КВ
   */
  "OfferTemplateFilter": {
    "kind": "class",
    "text": "Фильтр по шаблонам КВ",
    "fields": {
      /**
       * По статусам
       */
      "statusTypes": {
        "type": "OfferTemplate.StatusType",
        "text": "По статусам",
      },
      /**
       * По типам сервисов
       */
      "serviceTypes": {
        "type": "OfferTemplate.ServiceType",
        "text": "По типам сервисов",
      },
      /**
       * По идентификаторам регионов (из правил применимости)
       */
      "rfIds": {
        "type": "int32",
        "text": "По идентификаторам регионов (из правил применимости)",
      },
      /**
       * По тексту.
       * Если значение не передано, поиск по нему не производится.
       * # Диапазон: 3..64.
       * # Поиск производится по полям:
       * # - Наименование;
       * # - Описание
       */
      "text": {
        "type": "google.protobuf.StringValue",
        "text": "По тексту.\nЕсли значение не передано, поиск по нему не производится.\n# Диапазон: 3..64.\n# Поиск производится по полям:\n# - Наименование;\n# - Описание",
        "rules": {
          "minLength": {
            "value": 3,
            "message": "Значение не входит в допустимый диапазон. Минимум: 3"
          },
          "maxLength": {
            "value": 64,
            "message": "Значение не входит в допустимый диапазон. Максимум: 64"
          },
        }
      },
      /**
       * По типам договорных схем (из правил применимости)
       */
      "applicabilityRulesContractTypes": {
        "type": "OfferTemplate.ApplicabilityRules.ContractType",
        "text": "По типам договорных схем (из правил применимости)",
      },
      /**
       * По типам клиентов (из правил применимости)
       */
      "applicabilityRulesClientTypes": {
        "type": "OfferTemplate.ApplicabilityRules.ClientType",
        "text": "По типам клиентов (из правил применимости)",
      },
      /**
       * По типам биллинговых систем (из правил применимости)
       */
      "applicabilityRulesBillingSystemTypes": {
        "type": "OfferTemplate.ApplicabilityRules.BillingSystemType",
        "text": "По типам биллинговых систем (из правил применимости)",
      },
      /**
       * По признаку внешней оплаты умного домофона (из правил применимости)
       */
      "isExternalPaymentForSmartIntercom": {
        "type": "google.protobuf.BoolValue",
        "text": "По признаку внешней оплаты умного домофона (из правил применимости)",
      },
      /**
       * По наличию CMS телефона в квартире (из правил применимости)
       */
      "applicabilityRulesIsCmsPhone": {
        "type": "google.protobuf.BoolValue",
        "text": "По наличию CMS телефона в квартире (из правил применимости)",
      },
      /**
       * По наличию SIP телефона в квартире (из правил применимости)
       */
      "applicabilityRulesIsSipPhone": {
        "type": "google.protobuf.BoolValue",
        "text": "По наличию SIP телефона в квартире (из правил применимости)",
      },
      /**
       * По наличию видеомонитора в квартире (из правил применимости)
       */
      "applicabilityRulesIsVideoMonitor": {
        "type": "google.protobuf.BoolValue",
        "text": "По наличию видеомонитора в квартире (из правил применимости)",
      },
      /**
       * По типам договорной схемы устройства в квартире (из правил применимости)
       */
      "applicabilityRulesRoomDeviceContractTypes": {
        "type": "OfferTemplate.ApplicabilityRules.RoomDeviceContractType",
        "text": "По типам договорной схемы устройства в квартире (из правил применимости)",
      },
      /**
       * По типам минимального бесплатного пакета мобильного приложения (из правил применимости)
       */
      "applicabilityRulesMobileAppPackageTypes": {
        "type": "OfferTemplate.ApplicabilityRules.MobileAppPackageType",
        "text": "По типам минимального бесплатного пакета мобильного приложения (из правил применимости)",
      },
      /**
       * По признаку переадресации на городские/мобильные номера (из правил применимости)
       */
      "isCallForwardingEnabled": {
        "type": "google.protobuf.BoolValue",
        "text": "По признаку переадресации на городские/мобильные номера (из правил применимости)",
      },
      /**
       * По признаку цифрового клиентского пути (из правил применимости)
       */
      "isDigitalWay": {
        "type": "google.protobuf.BoolValue",
        "text": "По признаку цифрового клиентского пути (из правил применимости)",
      },
      /**
       * По идентификаторам технологических планов (из элементов шаблона)
       */
      "planIds": {
        "type": "int32",
        "text": "По идентификаторам технологических планов (из элементов шаблона)",
      },
    },
  },
  /**
   * Пагинация по шаблонам КВ
   */
  "OfferTemplatePaging": {
    "kind": "class",
    "text": "Пагинация по шаблонам КВ",
    "fields": {
      /**
       * Тип значения сортировки.
       * Если значение не передано, то будет взято значение по умолчанию.
       * # По умолчанию: CREATED_AT
       */
      "orderByType": {
        "type": "OfferTemplatePaging.OrderByType",
        "text": "Тип значения сортировки.\nЕсли значение не передано, то будет взято значение по умолчанию.\n# По умолчанию: CREATED_AT",
      },
      /**
       * Тип направления сортировки.
       * # По умолчанию: DESC
       */
      "directionType": {
        "type": "OfferTemplatePaging.DirectionType",
        "text": "Тип направления сортировки.\n# По умолчанию: DESC",
      },
      /**
       * Количество записей на страницу.
       * Если значение 0 (не передано), то будет взято значение по умолчанию.
       * # Диапазон: 0..100.
       * # По умолчанию: 20
       */
      "limit": {
        "type": "int32",
        "text": "Количество записей на страницу.\nЕсли значение 0 (не передано), то будет взято значение по умолчанию.\n# Диапазон: 0..100.\n# По умолчанию: 20",
        "rules": {
          "min": {
            "value": 0,
            "message": "Значение не входит в допустимый диапазон. Минимум: 0"
          },
          "max": {
            "value": 100,
            "message": "Значение не входит в допустимый диапазон. Максимум: 100"
          },
        }
      },
      /**
       * Сдвиг.
       * # Диапазон: 0..2147483647
       */
      "offset": {
        "type": "int32",
        "text": "Сдвиг.\n# Диапазон: 0..2147483647",
        "rules": {
          "min": {
            "value": 0,
            "message": "Значение не входит в допустимый диапазон. Минимум: 0"
          },
          "max": {
            "value": 2147483647,
            "message": "Значение не входит в допустимый диапазон. Максимум: 2147483647"
          },
        }
      },
    },
  },
  /**
   * Запрос создания/редактирования шаблона КВ
   */
  "PostOfferTemplateRequest": {
    "kind": "class",
    "text": "Запрос создания/редактирования шаблона КВ",
    "fields": {
      /**
       * Шаблон КВ.
       * Если id не передан — создаётся новый шаблон.
       * Если id передан — редактируется существующий шаблон
       */
      "data": {
        "type": "OfferTemplate",
        "text": "Шаблон КВ.\nЕсли id не передан — создаётся новый шаблон.\nЕсли id передан — редактируется существующий шаблон",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Ответ на запрос создания/редактирования шаблона КВ
   */
  "PostOfferTemplateResponse": {
    "kind": "class",
    "text": "Ответ на запрос создания/редактирования шаблона КВ",
    "fields": {
      /**
       * Шаблон КВ
       */
      "data": {
        "type": "OfferTemplate",
        "text": "Шаблон КВ",
      },
      /**
       * Ошибка
       */
      "error": {
        "type": "PostOfferTemplateResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка запроса сохранения шаблона КВ
   */
  "PostOfferTemplateResponse.Error": {
    "kind": "class",
    "text": "Ошибка запроса сохранения шаблона КВ",
    "fields": {
      /**
       * Ошибка валидации
       */
      "validation": {
        "type": "ValidationError",
        "text": "Ошибка валидации",
      },
      /**
       * Ошибка сохранения
       */
      "saving": {
        "type": "OfferTemplate.SavingError",
        "text": "Ошибка сохранения",
      },
    },
  },
  /**
   * Запрос восстановления шаблона КВ из архива
   */
  "PostOfferTemplateRestoreRequest": {
    "kind": "class",
    "text": "Запрос восстановления шаблона КВ из архива",
    "fields": {
      /**
       * Идентификатор шаблона КВ.
       * Тип: Guid
       */
      "id": {
        "type": "string",
        "text": "Идентификатор шаблона КВ.\nТип: Guid",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Ответ на запрос восстановления шаблона КВ из архива
   */
  "PostOfferTemplateRestoreResponse": {
    "kind": "class",
    "text": "Ответ на запрос восстановления шаблона КВ из архива",
    "fields": {
      /**
       * Восстановленный шаблон КВ
       */
      "data": {
        "type": "OfferTemplate",
        "text": "Восстановленный шаблон КВ",
      },
    },
  },
  /**
   * Ошибки валидации.
   * Эти проверки выполняются до обращения в базу данных
   */
  "ValidationError": {
    "kind": "class",
    "text": "Ошибки валидации.\nЭти проверки выполняются до обращения в базу данных",
    "fields": {
      /**
       * Путь к полю в формате наименования прото
       */
      "path": {
        "type": "string",
        "text": "Путь к полю в формате наименования прото",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Валидационное сообщение
       */
      "message": {
        "type": "string",
        "text": "Валидационное сообщение",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Справочник типов биллинговых систем
   */
  "OfferTemplate.ApplicabilityRules.BillingSystemType": {
    "kind": "enum",
    "text": "Справочник типов биллинговых систем",
    "values": {
      /**
       * Значение не указано
       */
      "BILLING_SYSTEM_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * Автоматизированная система расчётов макрорегионального филиала/АСР МРФ
       */
      "ASR_MRF": {
        "i": 1,
        "text": "Автоматизированная система расчётов макрорегионального филиала/АСР МРФ",
      },
      /**
       * Платформа Ключ
       */
      "KEY_PLATFORM": {
        "i": 2,
        "text": "Платформа Ключ",
      },
    },
  },
  /**
   * Справочник типов клиентов
   */
  "OfferTemplate.ApplicabilityRules.ClientType": {
    "kind": "enum",
    "text": "Справочник типов клиентов",
    "values": {
      /**
       * Значение не указано
       */
      "CLIENT_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * Управляющая компания
       */
      "MANAGEMENT_COMPANY": {
        "i": 1,
        "text": "Управляющая компания",
      },
      /**
       * Домофонная компания
       */
      "INTERCOM_COMPANY": {
        "i": 2,
        "text": "Домофонная компания",
      },
    },
  },
  /**
   * Справочник типов договорных схем
   */
  "OfferTemplate.ApplicabilityRules.ContractType": {
    "kind": "enum",
    "text": "Справочник типов договорных схем",
    "values": {
      /**
       * Значение не указано
       */
      "CONTRACT_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * Договор заключён с юридическим лицом
       */
      "B2B": {
        "i": 1,
        "text": "Договор заключён с юридическим лицом",
      },
      /**
       * Договор заключён с физическим лицом
       */
      "B2C": {
        "i": 2,
        "text": "Договор заключён с физическим лицом",
      },
      /**
       * Смешанная схема. Ростелеком работает с клиентом через партнёра
       */
      "B2B2C": {
        "i": 3,
        "text": "Смешанная схема. Ростелеком работает с клиентом через партнёра",
      },
    },
  },
  /**
   * Справочник типов минимального бесплатного пакета мобильного приложения
   */
  "OfferTemplate.ApplicabilityRules.MobileAppPackageType": {
    "kind": "enum",
    "text": "Справочник типов минимального бесплатного пакета мобильного приложения",
    "values": {
      /**
       * Значение не указано
       */
      "MOBILE_APP_PACKAGE_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * Кнопка открытия + Ключи
       */
      "OPEN_DOOR_AND_KEYS": {
        "i": 1,
        "text": "Кнопка открытия + Ключи",
      },
      /**
       * Кнопка открытия + Ключи + Аудиовызовы
       */
      "OPEN_DOOR_AND_KEYS_AUDIO_CALLS": {
        "i": 2,
        "text": "Кнопка открытия + Ключи + Аудиовызовы",
      },
      /**
       * Кнопка открытия + Ключи + Видеовызовы
       */
      "OPEN_DOOR_AND_KEYS_VIDEO_CALLS": {
        "i": 3,
        "text": "Кнопка открытия + Ключи + Видеовызовы",
      },
    },
  },
  /**
   * Справочник типов договорной схемы устройства в квартире
   */
  "OfferTemplate.ApplicabilityRules.RoomDeviceContractType": {
    "kind": "enum",
    "text": "Справочник типов договорной схемы устройства в квартире",
    "values": {
      /**
       * Значение не указано
       */
      "ROOM_DEVICE_CONTRACT_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * Житель заключает договор на квартирное устройство с внешней компанией
       */
      "ROOM_DEVICE_B2B": {
        "i": 1,
        "text": "Житель заключает договор на квартирное устройство с внешней компанией",
      },
      /**
       * Житель заключает договор на квартирное устройство с Ростелекомом
       */
      "ROOM_DEVICE_B2C": {
        "i": 2,
        "text": "Житель заключает договор на квартирное устройство с Ростелекомом",
      },
    },
  },
  /**
   * Справочник типов сервисов
   */
  "OfferTemplate.ServiceType": {
    "kind": "enum",
    "text": "Справочник типов сервисов",
    "values": {
      /**
       * Значение не указано
       */
      "SERVICE_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * Умный домофон
       */
      "INTERCOM": {
        "i": 1,
        "text": "Умный домофон",
      },
      /**
       * Комплексное видеонаблюдение
       */
      "CAMERAS": {
        "i": 2,
        "text": "Комплексное видеонаблюдение",
      },
      /**
       * Умные счётчики
       */
      "TELEMETRY": {
        "i": 3,
        "text": "Умные счётчики",
      },
      /**
       * Система контроля и управления доступом
       */
      "ACCESS_CONTROL_PANEL": {
        "i": 4,
        "text": "Система контроля и управления доступом",
      },
      /**
       * Умный шлагбаум
       */
      "BARRIER": {
        "i": 5,
        "text": "Умный шлагбаум",
      },
    },
  },
  /**
   * Справочник статусов шаблона КВ
   */
  "OfferTemplate.StatusType": {
    "kind": "enum",
    "text": "Справочник статусов шаблона КВ",
    "values": {
      /**
       * Значение не указано
       */
      "STATUS_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * Активен
       */
      "ACTIVE": {
        "i": 1,
        "text": "Активен",
      },
      /**
       * Архивирован
       */
      "ARCHIVED": {
        "i": 2,
        "text": "Архивирован",
      },
    },
  },
  /**
   * Справочник типов направлений сортировки.
   */
  "OfferTemplatePaging.DirectionType": {
    "kind": "enum",
    "text": "Справочник типов направлений сортировки.",
    "values": {
      /**
       * Значение не указано
       */
      "DIRECTION_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * От большего к меньшему
       */
      "DESC": {
        "i": 1,
        "text": "От большего к меньшему",
      },
      /**
       * От меньшего к большему
       */
      "ASC": {
        "i": 2,
        "text": "От меньшего к большему",
      },
    },
  },
  /**
   * Справочник типов значений сортировки.
   */
  "OfferTemplatePaging.OrderByType": {
    "kind": "enum",
    "text": "Справочник типов значений сортировки.",
    "values": {
      /**
       * Значение не указано
       */
      "ORDER_BY_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * По дате создания
       */
      "CREATED_AT": {
        "i": 1,
        "text": "По дате создания",
      },
      /**
       * По наименованию
       */
      "TITLE": {
        "i": 2,
        "text": "По наименованию",
      },
    },
  },
}